import {
  GET_SURVEY_RESULTS_SUCCESS,
  GET_SURVEY_RESULTS_FAILURE,
  GET_SURVEY_RESULTS_REQUESTED,
} from './surveyResults.constants'

const initialState = {
  loading: true,
  error: false,
  data: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SURVEY_RESULTS_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
        data: {},
      }
    case GET_SURVEY_RESULTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.data,
      }

    case GET_SURVEY_RESULTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: {},
      }

    default:
      return state
  }
}
